import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ManageProductAvailabilityPage } from "~/pages/Settings/Organisations/organisation/settings/ManageProductAvailabilityPage";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/settings/product-availability",
)({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.productAvailability") }],
  }),
  component: ManageProductAvailabilityPage,
});
